export default __webpack_public_path__ + "static/media/homeseller-keep.6b67ac79.jpg";